<template>
  <table class="table" data-role="content">
    <slot />
  </table>
</template>

<script>
import $ from 'jquery';
import dataTable from 'datatables.net-bs4';
import { close } from 'fs';
import { ka } from '../../utils/konalytics';

export default {
  name: 'k-datatable',
  props: ['options', 'dataList', 'dataKey', 'editorOptions', 'isLoading'],
  data: function() {
    return {
      eventTrackingTimeOut: null,
      editor: null,
      isDtReady: false,
      dt: null,
    };
  },
  mounted: function() {
    var vm = this;
    if (this.options.hasOwnProperty('initComplete')) {
      console.warn(
        'Datatable: @initComplete-al iratkozz fel a k-datatable komponensen!'
      );
    }
    var table = $(this.$el).dataTable({
      ...this.options,
      initComplete: function(settings, json) {
        vm.isDtReady = true;
        vm.$emit('initComplete', { settings, json });
      },
    });
    vm.dt = table;
    table.on('search.dt', function() {
      if (vm.eventTrackingTimeOut) {
        clearTimeout(vm.eventTrackingTimeOut);
        vm.eventTrackingTimeOut = null;
      }

      var searchTerm = table.DataTable().search();

      if (searchTerm) {
        vm.eventTrackingTimeOut = setTimeout(function() {}, 2000);
      }
    });

    setTimeout(function() {
      table.DataTable().rows.add(vm.dataList);
      table.DataTable().draw(false);
    }, 200);

    $(this.$el).on('click', 'tr', function() {
      var data = table
        .api()
        .row(this)
        .data();
      vm.$emit('rowClick', data);
    });
  },
  computed: {
    editorOptionsChanged() {
      return this.isDtReady + JSON.stringify(this.editorOptions);
    },
  },
  watch: {
    dataList: function(dataList, prev) {
      var table = $(this.$el);
      var key = this.dataKey;

      setTimeout(() => {
        table.DataTable().clear();
        table.DataTable().rows.add(dataList);
        table.DataTable().draw(false);
        // --------------------------------------------------------------------
        // Spike - ne töröld ki !!!!!
        // --------------------------------------------------------------------
        // --------------------------------------------------------------------
        // var array = this.chunkArray(dataList, 100);
        // console.log(array);
        // console.log(array.length);
        // var i = 0;
        // array.forEach(function(entry) {
        //   i++;
        //   setTimeout(function() {
        //     console.log('addCucc - ' + entry.length);
        //     table.DataTable().rows.add(entry);
        //     table.DataTable().draw();
        //     console.log('endCucc');
        //   }, i * 200);
        // });
        // for (var i = 0; i < array.length; i++) {
        //   setTimeout(function() {
        //     debugger;
        //     console.log('index - ' + i);
        //     console.log('addCucc - ' + array[i].length);
        //     table.DataTable().rows.add(array[i]);
        //     table.DataTable().draw();
        //     console.log('endCucc');
        //   }, i * 50);
        // }
        // --------------------------------------------------------------------
        // --------------------------------------------------------------------
      }, 250);
    },
    editorOptionsChanged: {
      handler: function(val) {
        if (!this.editorOptions) {
          return;
        }
        if (this.editor) {
          this.editor.close();
          this.editor.destroy();
        }
        this.editor = new $.fn.dataTable.Editor(this.editorOptions);

        this.editor.on('preSubmit', function(e, data, action) {
          try {
            let [keys, params] = Object.entries(data.data)[0];
            data.data = { id: keys, ...params };
          } catch (error) {
            console.error(error);
          }
        });
      },
      deep: true,
      immediate: true,
    },
    isLoading: {
      handler: function(val) {
        if (!this.$el) {
          return;
        }
        let $el = $(this.$el);
        if (val === true) {
          $(`#${$el.attr('id')}_processing`).show();
        } else {
          $(`#${$el.attr('id')}_processing`).hide();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    chunkArray: function(myArray, chunk_size) {
      var index = 0;
      var arrayLength = myArray.length;
      var tempArray = [];

      for (index = 0; index < arrayLength; index += chunk_size) {
        var myChunk = myArray.slice(index, index + chunk_size);
        // Do something if you want with the group
        tempArray.push(myChunk);
      }

      return tempArray;
    },
  },
  destroyed: function() {
    $(this.$el)
      .DataTable()
      .clear()
      .destroy();
  },
};
</script>
